import { render } from "./NoahAdmin.vue?vue&type=template&id=610f2dbe&scoped=true"
import script from "./NoahAdmin.vue?vue&type=script&lang=js"
export * from "./NoahAdmin.vue?vue&type=script&lang=js"

import "./NoahAdmin.vue?vue&type=style&index=0&id=610f2dbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f2dbe"]])

export default __exports__